export const TOAST_COLORS = {
  light:      { bg: '#ffffff', text: '#111827', border: '#e5e7eb' },
  dark:       { bg: '#1f2937', text: '#f9fafb', border: '#374151' },
  sports:     { bg: '#ffffff', text: '#14532d', border: '#bbf7d0' },
  ocean:      { bg: '#ffffff', text: '#164e63', border: '#a5f3fc' },
  sunset:     { bg: '#ffffff', text: '#7c2d12', border: '#fed7aa' },
  purple:     { bg: '#ffffff', text: '#581c87', border: '#e9d5ff' },
  darkGreen:  { bg: '#14532d', text: '#f0fdf4', border: '#166534' },
  darkBlue:   { bg: '#1e3a8a', text: '#eff6ff', border: '#1d4ed8' },
  darkPurple: { bg: '#581c87', text: '#faf5ff', border: '#7e22ce' },
  darkOrange: { bg: '#7c2d12', text: '#fff7ed', border: '#c2410c' },
};
